import type { TFunction } from "i18next";

import { SortBy } from "shared/types";

import { SelectOption } from "features/ui/Select";

export const NONE_EXPOSURE_ID = "none";

export const getNoneExposureOption = (t: TFunction): SelectOption => ({
  id: NONE_EXPOSURE_ID,
  value: t("common:none"),
});

export const TOP_CONTRIBUTORS_MAX_X_AXIS_CHARACTERS = 110;

export const getDropdownLabelMappings = (t: TFunction) => ({
  granularity: {
    day: t("common:analytics.granularity_day"),
    week: t("common:analytics.granularity_week"),
    month: t("common:analytics.granularity_month"),
  },
  xAxis: {
    engineManufacturedAt: t("common:analytics.x_axis_engine_manufactured"),
    vehicleManufacturedAt: t("common:analytics.x_axis_vehicle_manufactured"),
  },
});

export const NONE_SELECT_OPTION_ID = "null";

export const getNoneSelectOption = (t: TFunction): SelectOption => ({
  id: NONE_SELECT_OPTION_ID,
  value: t("common:none"),
  label: t("common:none"),
});

export const getXAxisOptions = (t: TFunction): SelectOption[] => [
  {
    id: "month",
    value: t("common:analytics.x_axis_option_month_value"),
    label: t("common:analytics.x_axis_option_month_label"),
  },
  {
    id: "week",
    value: t("common:analytics.x_axis_option_week_value"),
    label: t("common:analytics.x_axis_option_week_label"),
  },
  {
    id: "day",
    value: t("common:analytics.x_axis_option_day_value"),
    label: t("common:analytics.x_axis_option_day_label"),
  },
];

const getEventsYAxisOption = (t: TFunction): SelectOption => ({
  id: "events",
  value: t("common:event_type.event_other"),
  label: t("common:event_type.event_other"),
});

const getAffectedVehiclesYAxisOption = (t: TFunction): SelectOption => ({
  id: "affectedVehicles",
  value: t("common:analytics.by_age.affected_vehicles_label"),
  label: t("common:analytics.by_age.affected_vehicles_label"),
});

export const getIPTVYAxisOption = (t: TFunction): SelectOption => ({
  id: "IPTV",
  value: t("common:analytics.incidents_per_thousand_vehicles"),
  label: t("common:analytics.incidents_per_thousand_vehicles"),
});

export const getTotalCostYAxisOption = (t: TFunction): SelectOption => ({
  id: "totalCost",
  value: t("common:analytics.total_cost"),
  label: t("common:analytics.total_cost"),
});

export const getTotalDowntimeYAxisOption = (t: TFunction): SelectOption => ({
  id: "downtime",
  value: t("common:analytics.total_downtime_hours"),
  label: t("common:analytics.total_downtime_hours"),
});

export const getBaseYAxisOptions = (t: TFunction): SelectOption[] => [
  getEventsYAxisOption(t),
  getAffectedVehiclesYAxisOption(t),
];

export const TOP_CONTRIBUTORS_DEFAULT_SORT: SortBy = { IPTV: "desc" };
export const TOP_CONTRIBUTORS_CHART_DATA_LIMIT = 15;
export const DEFAULT_ANALYTICS_PAGE_CLASSES = "pb-10 px-8 pt-5";
